<script>
/* COMPOSANTS */

/* MIXINS */
import backMixin from '@mixins/backMixin';
import titleMixin from '@mixins/titleMixin';

export default {
  mixins: [backMixin, titleMixin],
  props: {
    details: {type: Boolean, required: false, default: true},
    scrollable: {type: Boolean, required: false, default: false},
    justListView: {type: Boolean, required: false, default: false},
    titleCenter: {type: Boolean, required: false, default: false},
    showTitle: {type: Boolean, required: false, default: true},
    gapColumn: {type: String, required: false, default: 'gap-4'},
    title: {type: String, required: false, default: undefined},
  },
  computed: {
    hasLeftSlot() {
      return !!this.$slots.left;
    },
    hasRightSlot() {
      return !!this.$slots.right;
    },
    maxWidth() {
      let width = 5;
      if (this.hasLeftSlot) width = width - 1;
      if (this.hasRightSlot) width = width - 1;
      return width;
    },
  },
};
</script>

<template>
  <div>
    <div class="flex md:flex-row flex-col justify-between items-center mb-3">
      <div
        v-if="!titleCenter && showTitle"
        class="hidden md:flex items-center justify-items-start w-full md:flex-1 md:w-auto gap-2 min-h-[40px]">
        <a v-if="hasBack" @click="goBack" class="hover:cursor-pointer">
          <i class="ga-icon ga-chevron_left text-2xl font-bold text-grey-900" />
        </a>
        <span class="font-inter text-grey-900 font-bold text-xl">{{ this.titleLocal }}</span>
      </div>
      <div class="flex gap-2 items-center justify-end w-full md:w-auto flex-wrap">
        <slot name="action" />
      </div>
    </div>
    <div class="flex md:flex-row flex-col" :class="[gapColumn]">
      <div class="md:w-1/5 w-full" v-if="hasLeftSlot">
        <component
          :is="this.$isMobile() ? 'div' : 'perfect-scrollbar'"
          class="md:h-content-scroll h-full p-3"
          :options="{suppressScrollX: true}">
          <slot name="left" />
        </component>
      </div>
      <div class="flex-1" :class="'md:w-' + this.maxWidth + '/5'">
        <div
          v-if="titleCenter && showTitle"
          class="hidden md:flex items-center justify-items-start w-full md:flex-1 md:w-auto gap-2 min-h-[40px]">
          <a v-if="hasBack" @click="goBack" class="hover:cursor-pointer">
            <i class="ga-icon ga-chevron_left text-2xl font-bold text-grey-900" />
          </a>
        </div>
        <div
          v-if="!justListView && !this.$isMobile()"
          class="p-3 border-solid border-[#F1F2F5] rounded-lg"
          :class="[{'layout-scrollable': this.scrollable, 'bg-detailsBg': this.details, border: !this.details}]">
          <component
            :is="this.$isMobile() ? 'div' : 'perfect-scrollbar'"
            :options="{suppressScrollX: true}"
            class="md:h-content-scroll h-full">
            <slot name="content" />
          </component>
        </div>
        <div v-else class="p-3 border-solid border-[#F1F2F5] rounded-lg bg-detailsBg">
          <slot name="content" />
        </div>
      </div>
      <div class="md:w-1/5 w-full" v-if="hasRightSlot">
        <component
          :is="this.$isMobile() ? 'div' : 'perfect-scrollbar'"
          class="md:h-content-scroll h-full p-3"
          :options="{suppressScrollX: true}">
          <slot name="right" />
        </component>
      </div>
    </div>
    <slot name="empty" />
    <slot name="extra" />
  </div>
</template>
